// extracted by mini-css-extract-plugin
export default {"accordion":"m4kM_","item":"S5QOl","wrapperTitle":"uY5xm","wrapperIcon":"wLAkN","icon":"Y3ofq","title":"LBFHD","description":"_10wez"};